/**
 * 学位枚举
 */
export default Object.freeze(['博士', '硕士', '学士', '其他'])